<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('MANAGEGROUPS.ADD_GPT_GROUP')}}
  v-card-text.mt-7
    v-form(v-model="valid", ref="form")
      // 名稱
      v-row
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEGROUPS.NAME')}}
        v-col.pa-0
          v-text-field.mb-1(
            v-model='addData.name',
            outlined,
            :placeholder=`$t('MANAGEGROUPS.NAME')`,
            dense
            :rules='formRule.nameRules',
            required='required',
            :hint=`$t('MANAGEGROUPS.NAME_HINT')`,
            persistent-hint
          )
      //- // 類型 (知識庫、AI助理)
      //- v-row
      //-   v-col.pa-0(cols='3').d-flex.justify-start
      //-     div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEGROUPS.TYPE')}}
      //-   v-col.pa-0
      //-     v-select.bg-white.mb-2(
      //-       v-model='addData.permission_type',
      //-       :items="permissionTypeList",
      //-       item-value="key",
      //-       item-text="name",
      //-       outlined,
      //-       :placeholder=`$t('MANAGEGROUPS.TYPE')`,
      //-       dense
      //-       :rules='formRule.fieldRules',
      //-       required='required',
      //-       :hint=`$t('MANAGEGROUPS.TYPE_HINT')`,
      //-       persistent-hint
      //-     )
      // 成員
      v-row.mb-4
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEGROUPS.MEMBER')}}
        v-col.pa-0
          v-select.bg-white(
            v-model="addData.user_set",
            :items="filteredOwnerList",
            item-value="id",
            item-text="fullName",
            return-object,
            multiple,
            chips
            outlined,
            :placeholder=`$t('MANAGEGROUPS.MEMBER')`,
            dense
            :rules='formRule.userfieldRules',
            required='required',
            :hint=`$t('MANAGEGROUPS.MEMBER_HINT')`,
            persistent-hint
            :menu-props="{ contentClass: 'member-select-dropdown custom-list' }"
          )
            template(v-slot:prepend-item)
              div.member-select-header.custom-list
                div.pt-2.pb-1
                  v-text-field.member-search-field(
                    v-model="memberSearch"
                    dense
                    hide-details
                    :placeholder="$t('MANAGEGROUPS.MEMBER_SEARCH')"
                    prepend-inner-icon="mdi-magnify"
                    @click.stop
                    @keydown.stop
                  )
                v-list-item(ripple @mousedown.prevent @click="toggleSelectAllMembers")
                  v-list-item-action
                    v-icon(:color="isAllMembersSelected || isSomeMembersSelected ? 'indigo darken-4' : ''") {{ selectAllMembersIcon }}
                  v-list-item-content
                    v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                v-divider.my-1
            template(v-slot:item="{ item, on, attrs }")
              v-list-item(v-bind="attrs" v-on="on")
                v-list-item-action
                  v-icon(:color="attrs.inputValue ? 'gray' : ''") {{ attrs.inputValue ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                v-list-item-content
                  v-tooltip(bottom)
                    template(v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }")
                      v-list-item-title.text-truncate(v-bind="tooltipAttrs" v-on="tooltipOn")
                        span {{ item.fullName }}（{{ item.email }}）
                    span {{ item.email }}
            template(v-slot:selection="{ item, index }")
              v-chip(v-if="index === 0" small style="max-width: 200px;")
                span(style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;") {{ item.fullName }}
              span(v-if="index === 1" class="grey--text text-caption" style="font-size: 8px;") +{{ addData.user_set.length - 1 }}
    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
      v-btn.mr-4(
        :ripple="false",
        @click="onCancel",
        width="100",
        height="40",
        color="cancel",
        depressed,
        outlined,
        style='font-weight: 700;'
      ) Cancel
      v-btn.mr-6(
        :ripple="false",
        @click="onConfirm",
        width="100",
        height="40",
        color="#14C6DE",
        depressed,
        dark,
      )
        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.ADD')}}

  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')

</template>

<script>
import Vue from "vue";
import i18n from '/common/plugins/vue-i18n.js';
import messageDialog from '@/components/Dialog/redirectDialog';
import errorDialog from "@/components/Dialog/errorDialog";
import permissionTypeList from "@/array/the_GPTpermissionTypeList";
import OrganizationDataService from "@/services/OrganizationDataService";
import PermissionService from "@/services/PermissionService";

export default Vue.extend({
  props: {
  },
  components: {            
    messageDialog,
    errorDialog
  },
  data() {
    return {
      valid: true,
      addData : this.initializeAddGroupData(),
      formRule: {
        nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,30}$/.test(v) || i18n.t('RULE.RULE_30'),
        ],
        fieldRules: [(v) => !!v || i18n.t('RULE.RULE_R'),],
        userfieldRules: [(v) =>  v.length>0 || i18n.t('RULE.RULE_R')],
      },
      messageDialog:false,
      message:"",
      errorDialog:false,
      errorMessage:"",
      permissionTypeList: permissionTypeList,
      ownerList: [],
      addBtn_loading:false,
      memberSearch: '',
    };
  },
  async created(){
    await OrganizationDataService.getowner().then((respose)=>{
      this.ownerList = respose.data;
      this.ownerList.forEach(item => {
          item.fullName = item.last_name + ' ' + item.first_name
      });
    });
  },
  computed: {
    isAllMembersSelected() {
      if (this.filteredOwnerList.length === 0) return false;
      const selectedIds = new Set(this.addData.user_set.map(item => item.id));
      return this.filteredOwnerList.every(item => selectedIds.has(item.id));
    },
    isSomeMembersSelected() {
      if (this.filteredOwnerList.length === 0) return false;
      const selectedIds = new Set(this.addData.user_set.map(item => item.id));
      const selectedCount = this.filteredOwnerList.filter(item => selectedIds.has(item.id)).length;
      return selectedCount > 0 && selectedCount < this.filteredOwnerList.length;
    },
    selectAllMembersIcon() {
      if (this.isAllMembersSelected) return 'mdi-checkbox-marked';
      if (this.isSomeMembersSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    filteredOwnerList() {
      if (!this.memberSearch) return this.ownerList;
      const search = this.memberSearch.toLowerCase();
      return this.ownerList.filter(item => {
        const name = (item.fullName || '').toLowerCase();
        const email = (item.email || '').toLowerCase();
        return name.includes(search) || email.includes(search);
      });
    },
  },
  methods: {
    toggleSelectAllMembers() {
      this.$nextTick(() => {
        if (this.isAllMembersSelected || this.isSomeMembersSelected) {
          const filteredIds = new Set(this.filteredOwnerList.map(item => item.id));
          this.addData.user_set = this.addData.user_set.filter(item => !filteredIds.has(item.id));
        } else {
          const existingIds = new Set(this.addData.user_set.map(item => item.id));
          const toAdd = this.filteredOwnerList.filter(item => !existingIds.has(item.id));
          this.addData.user_set = [...this.addData.user_set, ...toAdd];
        }
      });
    },
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    initializeAddGroupData() {
        return {
            id: "",
            name: "",
            types: "",
            user_set: [],
        };
    },
    async onConfirm() {
      if (this.validateForm() && !this.addBtn_loading) {
        this.addBtn_loading = true;
        this.addData.permission_type = "UPGPT";
        await PermissionService.addGroup(this.addData).then((response)=>{ 
          if(response.data == "same group name block"){
            this.showErrorDialog(i18n.t('MANAGEGROUPS.ERROR_2'));
            this.addBtn_loading = false;
          }else{
            this.addBtn_loading = false;
            this.$emit("emitAddDialog", true);
          }
        }).catch((exception) => {
          this.showErrorDialog(exception);
          this.addBtn_loading = false;
        });
      }
    },
    onCancel() {     
      this.$emit("emitAddDialog", false);
    },
    showMessageDialog(msg) {                
        this.messageDialog = true;
        this.message = msg;
    },
    async onEmitMessageDialog(val) {
      if(val){
        // 
      }
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
  },
});
</script>

<style>
.member-search-field .v-input__slot {
  padding: 0 12px !important;
}
.member-search-field input {
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.5px;
}
.member-select-dropdown {
  background: #FFFFFF !important;
  box-shadow: 0px 0px 8px rgba(153, 153, 153, 0.5) !important;
  border-radius: 4px !important;
  padding: 93px 0 4px 0 !important;
  width: 344px !important;
  min-height: 281px !important;
  max-height: 281px !important;
  overflow: hidden !important;
}
.member-select-dropdown .v-select-list {
  position: static !important;
  overflow-y: auto !important;
  max-height: 188px !important;
}
.member-select-header {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #FFFFFF !important;
  z-index: 2 !important;
}
.custom-list,
.custom-list .v-select-list {
    overflow-x: hidden;
}
.custom-list::-webkit-scrollbar,
.custom-list .v-select-list::-webkit-scrollbar {
    width: 6px; /* 調整滾動條寬度 */
}
.custom-list::-webkit-scrollbar-track,
.custom-list .v-select-list::-webkit-scrollbar-track {
    background:  var(--portal_menubar_background) !important;
}
.custom-list::-webkit-scrollbar-thumb,
.custom-list .v-select-list::-webkit-scrollbar-thumb {
    background: rgba(136, 136, 136, 0.3) ;
    border-radius: 10px;
}
</style>